import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { FEATURED_SERVICES } from "../../data/content";
import { SectionHeading, Reveal } from "../primitives";

export default function FeaturedServices() {
  return (
    <section data-testid="featured-services" className="relative bg-ink-soft/40 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="What we do"
          title="Three ways we help your business thrive"
          sub="From your first website to full technology management — pick a starting point, and we'll guide the rest."
        />

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {FEATURED_SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.1}>
              <Link to="/services" state={{ open: s.id }} data-testid={`featured-service-${s.id}`}>
                <motion.article
                  whileHover={{ y: -8 }}
                  transition={{ type: "spring", stiffness: 260, damping: 20 }}
                  className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03]"
                >
                  <div className="relative h-44 overflow-hidden">
                    <img
                      src={s.image}
                      alt={s.title}
                      className="h-full w-full object-cover opacity-70 transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
                    <span className="absolute left-6 top-6 flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-gradient shadow-lg">
                      <s.icon className="h-5 w-5 text-white" strokeWidth={2} />
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-8">
                    <div className="flex items-start justify-between gap-3">
                      <h3 className="font-heading text-xl font-semibold text-white">{s.title}</h3>
                      <ArrowUpRight className="h-5 w-5 shrink-0 text-muted-foreground transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-brand" />
                    </div>
                    <p className="mt-2 text-sm text-brand-gold/90">{s.tagline}</p>
                    <ul className="mt-6 space-y-2.5">
                      {s.points.slice(0, 5).map((p) => (
                        <li key={p} className="flex items-center gap-2.5 text-sm text-muted-foreground">
                          <Check className="h-4 w-4 shrink-0 text-brand" />
                          {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                </motion.article>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
